<success-screen bgImage="coinsCrypto" class="bp-modal mod-lg">
  <bp-modal-header header [title]="'swap_crypto' | translate">
    <a (click)="close()" right (keydown.enter)="close()" [tabIndex]="0">{{ "close" | translate }}</a>
  </bp-modal-header>
  <div content>
    <div class="success-content-inner">
      <span class="price-alert-button" (click)="addPriceAlert(swapSuccessTrades[1].getCurrencyId())">
        <svg-inline
          class="icon-status-forward price-alert-bell-icon"
          src="assets/images/icons/icon-pricealert-add.svg"
          [alt]="'forward_alt_text' | translate" />
      </span>
      <ng-lottie width="190px" height="190px" [options]="successAnimationOptions"></ng-lottie>
      <div class="success-headline mb-15">{{ "swap_successful" | translate }}</div>
      @if (isIndexSwap()) {
        <p class="text-center mb-15 font-size-17">
          @switch (getIndexSwapType()) {
            @case ('fromIndex') {
              <span>
                {{
                "swap_index_from_success"
                | translate
                : [
                swapSuccessTrades[0]?.getAmount()
                | fiat_precision_symbol: getIndexPipeOption(),
                getTradableName(0),
                (swapSuccessTrades[1]?.getAmountTradable()
                | tradable_precision_symbol
                : {
                id: swapSuccessTrades[1]?.getCurrencyId(),
                dustThreshold: 0.0001
                }) +
                " (" +
                getTradableName(1) +
                ")"
                ]
                : false
                }}
              </span>
            }
            @case ('toIndex') {
              <span>
                {{
                "swap_index_to_success"
                | translate
                : [
                swapSuccessTrades[0]?.getAmountTradable()
                | tradable_precision_symbol
                : {
                id: swapSuccessTrades[0]?.getCurrencyId(),
                dustThreshold: 0.0001
                },
                swapSuccessTrades[1]?.getAmount()
                | fiat_precision_symbol: getIndexPipeOption(),
                getTradableName(1)
                ]
                : false
                }}
              </span>
            }
            @case ('betweenIndex') {
              <span>
                {{
                "swap_index_to_index_success"
                | translate
                : [
                swapSuccessTrades[0]?.getAmount()
                | fiat_precision_symbol: getIndexPipeOption(),
                getTradableName(0),
                swapSuccessTrades[1]?.getAmount()
                | fiat_precision_symbol: getIndexPipeOption(),
                getTradableName(1)
                ]
                : false
                }}
              </span>
            }
          }
        </p>
      } @else {
        <p class="text-center mb-15 font-size-17">
          <!-- From -->
          <span>{{ "swap_success_text" | translate }}</span>
          <br />
          <strong>
            {{
            swapSuccessTrades[0]?.getAmountTradable()
            | tradable_precision_symbol
            : { id: swapSuccessTrades[0]?.getCurrencyId(), dustThreshold: 0.0001 }
            }}
            {{ getCurrencySymbol(swapSuccessTrades[0]) }}
          </strong>
          ({{ swapSuccessTrades[0]?.getCurrencyId() | tradable_name }})
          {{ "into_success_screen" | translate }}
          <!-- To -->
          <strong>
            {{
            swapSuccessTrades[1]?.getAmountTradable()
            | tradable_precision_symbol
            : { id: swapSuccessTrades[1]?.getCurrencyId(), dustThreshold: 0.0001 }
            }}
            {{ getCurrencySymbol(swapSuccessTrades[1]) }}
          </strong>
          ({{ swapSuccessTrades[1]?.getCurrencyId() | tradable_name }})
        </p>
      }
    </div>
    <!-- Share and portfolio buttons -->
    <div class="text-center center-block mt-20 ml-80 mr-80">
      <button (click)="shareTrade()" class="btn btn-primary btn-success-modal mb-10" type="button">
        <svg-inline
          class="icon-status-forward mr-10 share-icon"
          src="assets/images/icons/icon-share.svg"
          [alt]="'forward_alt_text' | translate" />
        <strong>{{ "share_this_trade_button_title" | translate }}</strong>
      </button>
      <button
        (click)="goToPortfolio()"
        class="btn btn-primary btn-success-modal mod-middle button-weight"
        type="button">
        <strong>{{ "go_to_portfolio" | translate }}</strong>
      </button>
    </div>
  </div>
</success-screen>
